import React, { useMemo } from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import IriusRiskCredentialsForm from "./IriusRiskCredentialsForm";
import IriusRiskMappingForm from "./IriusRiskMappingForm";

export default function IriusRiskConfigListing(props) {
  const columns = useMemo(
    () => [
      {
        title: "Project",
        dataIndex: "projectName",
        width: 240,
      },
    ],
    []
  );
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={IriusRiskMappingForm}
      CredentialsForm={IriusRiskCredentialsForm}
      extraColumns={columns}
    />
  );
}
